module.exports = __webpack_public_path__ + "assets/img/tgsm7.94207931.png";